import styled from 'styled-components';

export const Container = styled.div`
  .back-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: none;
    padding: 0;
    color: #007bff;
    font-size: 0.85rem;
    cursor: pointer;
    margin-bottom: 16px;
  }

  .back-link .material-icons {
    font-size: 18px;
  }

  .detail-card {
    border: 1px solid #ced4da;
    border-radius: 8px;
    padding: 20px;
    max-width: 960px;
    margin: 0 auto;
  }

  .badges {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin: 16px 0 10px;
  }

  .badge-pill {
    background: #28a745;
    color: #fff;
    font-size: 0.7rem;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 4px;
  }

  .detail-title {
    font-size: 1.15rem;
    font-weight: 700;
    color: #000;
    margin-bottom: 10px;
  }

  .detail-description {
    font-size: 0.95rem;
    font-weight: 400;
    color: #000;
    white-space: pre-line;
    line-height: 1.6;
  }

  .empty-state {
    text-align: center;
    color: #888;
    padding: 60px 20px;
  }

  .loading-wrapper {
    display: flex;
    justify-content: center;
    padding: 60px 0;
  }
`;
